import { Button, ButtonGroup, Modal } from "@datapay-by-datacom/design-system";
import { Heading } from "react-aria-components";
import s from "./ReplaceCompanyCsvConfirmModal.module.css";

export interface UnsavedProgressConfirmModalProps {
  isOpen: boolean;
  onStay: () => void;
  onLeave: () => void;
  title?: string;
  message?: string;
}

export function UnsavedProgressConfirmModal({
  isOpen,
  onStay,
  onLeave,
  title = "Leave bulk company creation?",
  message = "Uploaded companies, edits, and validation progress will be lost.",
}: UnsavedProgressConfirmModalProps) {
  return (
    <Modal isOpen={isOpen}>
      <div className={s.modalContent}>
        <Heading slot="title" className={s.title}>
          {title}
        </Heading>
        <p className={s.message}>{message}</p>
        <div className={s.actions}>
          <ButtonGroup>
            <Button variant="primary" onPress={onStay}>
              Stay
            </Button>
            <Button variant="tertiary" onPress={onLeave}>
              Leave anyway
            </Button>
          </ButtonGroup>
        </div>
      </div>
    </Modal>
  );
}
